package top.wcpe.allincore.ui.runtime.reactive

import kotlin.jvm.JvmStatic

/**
 * 响应式系统静态门面，提供 SolidJS 风格的 `signal` / `computed` / `effect` 构造入口。
 */
object Reactive {

    /** 创建一个可变信号。 */
    @JvmStatic
    fun <T> signal(initial: T): Signal<T> = MutableSignal(initial)

    /** 创建一个懒求值的派生计算。 */
    @JvmStatic
    fun <T> computed(supplier: () -> T): Computed<T> = Computed(supplier)

    /** 创建一个副作用；构造时立即执行一次并自动追踪依赖。 */
    @JvmStatic
    fun effect(runnable: EffectBody): Effect = Effect(runnable)
}
